<div class="imagecontainer" >
    <div *ngIf="!imgUrl" [ngSwitch]="isEdit" class="noImage">
        <div *ngSwitchCase="true">
            <img src="../../../../assets/images/photo.png" />
            <p class="ml-3">{{"IMAGEUPLOADCOMPONENT.UPLOADIMAGE" | translate}}</p>
						<!-- <button nbButton size="tiny" status="primary"><nb-icon icon="star"></nb-icon></button> -->
            <input class="pointer" type="file" accept="image/*" appNetworkCheck />
        </div>
        <div *ngSwitchCase="false">
            <img src="../../../../assets/images/no-image.png" class="no-image" />
        </div>

    </div>
    <div *ngIf="imgUrl" class="image" [style.background-image]="'url(' + imgUrl + ')'">
        <div class="delete pointer" (click)="deleteImage()" *ngIf="isEdit" [style.visibility]="isShowDelete ? 'visible' : 'hidden'">
						<nb-icon icon="trash-2-outline" class="pointer color-red-text" nbTooltip="{{'IMAGEUPLOADCOMPONENT.DELETEIMAGE' | translate}}" nbTooltipPlacement="top"></nb-icon>
        </div>
    </div>
</div>
